module.exports = __webpack_public_path__ + "static/media/zoom-out.33f5edd7.svg";